import React from 'react';
import classNames from 'classnames';
import { alpha, Box, IconButton, IconButtonProps, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import CloseIcon from '@mui/icons-material/Close';

const ICON_BACKGROUND_OPACITY = 0.6;

const useStyles = makeStyles((theme: Theme) => {
  const iconBackground = alpha('#000', ICON_BACKGROUND_OPACITY);

  return {
    action: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      zIndex: 3,
    },
    icon: {
      color: 'white',
      backgroundColor: iconBackground,
      '&:hover': {
        backgroundColor: iconBackground,
      },
    },
  };
});

type ClassesKeys = 'action' | 'icon';

export interface RemoveActionProps {
  classes?: Partial<Record<ClassesKeys, string>>;
  onClick?: () => void;
  size?: IconButtonProps['size'];
}

const RemoveAction: React.FC<RemoveActionProps> = (
  props: RemoveActionProps
) => {
  const { classes: externalClasses, onClick, size } = props;
  const classes = useStyles();
  return (
    <Box className={classNames(classes.action, externalClasses?.action)}>
      <IconButton
        classes={{ root: classNames(classes.icon, externalClasses?.icon) }}
        onClick={onClick}
        size={size}
      >
        <CloseIcon color="inherit" fontSize="inherit" />
      </IconButton>
    </Box>
  );
};

export default RemoveAction;
